import { useEffect, useState } from "react";
import toastr from "toastr";
import Input from "../../../utils/components/Input";
import Modal from "../../../utils/components/Modal";

const UpdatePersonalInfoForm = ({
  userInfo,
  setUserInfo,
  modalShow,
  setModalShow,
  translate,
  updateUserData,
}) => {
  const [isSending, setIsSending] = useState(false);
  const [updateInfo, setUpdateInfo] = useState({
    name: "",
    email: "",
    password: "",
    passwordConfirm: "",
  });

  useEffect(() => {
    if (userInfo) {
      setUpdateInfo({
        name: userInfo.name,
        email: userInfo.email,
        password: "",
        passwordConfirm: "",
      });
    }
  }, [userInfo, modalShow]);

  const handleChange = (e) =>
    setUpdateInfo({
      ...updateInfo,
      [e.target.name]: e.target.value,
    });

  const handleSubmit = (e) => {
    e.preventDefault();

    if (isSending) return;

    if (!updateInfo.name || !updateInfo.email) {
      setIsSending(false);
      return;
    }

    setIsSending(true);

    const params = {
      name: updateInfo.name,
      email: updateInfo.email,
    };

    if (updateInfo.password) {
      if (updateInfo.password !== updateInfo.passwordConfirm) {
        toastr.error(translate("account.passwords_do_not_match"));
        setIsSending(false);
        return false;
      }

      params.password = updateInfo.password;
    }

    updateUserData(params, (status) => {
      if (status) {
        setIsSending(false);
        setModalShow(false);
      } else {
        setIsSending(false);
      }
    });
  };

  return (
    <Modal
      title={translate("account.update_user_modal_title")}
      positiveButtonNode={translate("apply")}
      negativeButtonNode={translate("cancel")}
      positiveButtonHandler={handleSubmit}
      modalSize="xl"
      show={modalShow}
      setShow={(e) => setModalShow(e)}
      disableButtons={isSending}
    >
      <div className="row">
        <div className="col-12 col-md-6 mt-4">
          <Input
            type="text"
            name="name"
            placeholder={translate("name")}
            value={updateInfo["name"] || ""}
            onChange={handleChange}
          />
        </div>
        <div className="col-12 col-md-6 mt-4">
          <Input
            type="email"
            name="email"
            placeholder={translate("email")}
            value={updateInfo["email"] || ""}
            onChange={handleChange}
          />
        </div>
      </div>
      <div className="row">
        <div className="col-12 col-md-6 mt-4">
          <Input
            type="password"
            name="password"
            placeholder={translate("password")}
            value={updateInfo["password"] || ""}
            onChange={handleChange}
          />
        </div>
        <div className="col-12 col-md-6 mt-4">
          <Input
            type="password"
            name="passwordConfirm"
            placeholder={translate("confirm_password")}
            value={updateInfo["passwordConfirm"] || ""}
            onChange={handleChange}
          />
        </div>
      </div>
    </Modal>
  );
};

export default UpdatePersonalInfoForm;
